import { ALL_PROPERTY_LIST, ALL_PROPERTY_DETAIL } from "./actions";

const initialState = {
  allProperty: {
    docs: [],
    totalDocs: 0,
    limit: 0,
    page: 0,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },

  propertyLoading: true,
  allPropertyData: {},
};

const allPropertyReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ALL_PROPERTY_LIST:
      return {
        ...state,
        allProperty: payload,
        propertyLoading: false,
      };
    case ALL_PROPERTY_DETAIL:
      return {
        ...state,
        allPropertyData: payload,
        propertyLoading: false,
      };

    default:
      return state;
  }
};

export default allPropertyReducer;
